/* IotDeviceGridViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./IotDeviceGridViewRenderer");
const Registrations = require("../../../../../RegistrationNamespaces");

const DeviceTypeColumn = require("./column_renderers/device_type/DeviceTypeComponent");
const DeviceDiscoveryStatusColumn = require("./column_renderers/discovery_status/DeviceDiscoveryStatusComponent");
const ManagementStateColumn = require("./column_renderers/management_state/ManagementStateComponent");
const EnvironmentColumn = require("./column_renderers/environment/EnvironmentComponent");
const DateColumn = require("./column_renderers/date/DateComponent");
const LicenseColumn = require("./column_renderers/licence_status/DeviceLicenseStatusComponent");
const CustomFieldsColumn = require("./column_renderers/custom_fields/CustomFieldsComponent");
const SitePathColumn = require("./column_renderers/site_path/SitePathComponent");
const AccessStatusColumn = require("./column_renderers/access_status/AccessStatusComponent");
const SiteTypeColumn = require("./column_renderers/site_type/SiteTypeComponent");
const SiteCodeColumn = require("./column_renderers/site_code/SiteCodeComponent");
const CmdbSyncStatusColumn = require("./column_renderers/cmdb_sync_status/CmdbSyncStatusComponent.js");
const PlanStatusColumn = require("../../../deviceexplorer/views/device_grid_view/column_renderers/plan_status/PlanStatusComponent");
const TagsColumn = require("../../../../column_renderers/tags/TagsComponent");
// const DefaultNumericColumn = require("./column_renderers/default_numeric/DefaultNumericComponent");
const PagingDeviceFeed = require("./PagingDeviceFeed");
const TreeUtils = require("../../../siteexplorer/treeUtilities.js");

const _ = require("lodash");

const {
    DEVICE_DISCOVERY_STATUSES,
    DEVICE_CUSTOM_FIELDS,
    DEVICE_MANAGEMENT_STATES,
    DEVICE_ENVIRONMENTS,
    LICENSE_STATUS,
    SOLUTION_DEFAULT_SHOWN_COLUMNS_IOT,
    LICENSE_RESTRICTED_COLUMNS,
} = require("../../../deviceexplorer/views/device_grid_view/deviceConstants.js");

// OS Family options for grid column filtering
const OS_FAMILY_OPTIONS = {
    Windows: {
        name: "Windows",
        title: "Windows",
    },
    Debian: {
        name: "Debian",
        title: "Debian",
    },
};

class IotDeviceGridViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        steveUtils,
        DeviceEntity,
        VendorApiConfigEntity,
        CustomFieldsEntity,
        userSession,
        storageFactory,
        solutionsManager,
        modalUserFeedback,
        licenseRestriction,
        OsImageServerEntity,
        di,
        SiteEntity,
        CredentialsEntity,
        ConstructType,
        ExtendedPropType,
        ValueMap,
        Tags
    ) {
        super(di);
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._steveUtils = steveUtils;
        this._DeviceEntityDef = DeviceEntity;
        this._VendorApiConfigEntityDef = VendorApiConfigEntity;
        this._CustomFieldsEntityDef = CustomFieldsEntity;
        this._userSession = userSession;
        this._constructTypeEntityDef = ConstructType;
        this._extendedPropTypeEntityDef = ExtendedPropType;
        this._TagsEntity = Tags;
        this._modalUserFeedback = modalUserFeedback;
        this._solutionsManager = solutionsManager;
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "iotDeviceExplorer";
        this._storageFactory = storageFactory;
        this._userGridData = undefined; //new UserGridData(this._gridKey);
        this._pagingDeviceFeed = undefined;
        this._controlledDeviceNames = [];
        this._controlledDeviceIDs = [];
        this._nodeProps = {};
        this._isCiscoSupportEnabled = undefined;
        this._siteEntityDef = SiteEntity;
        this._osImageServerEntity = OsImageServerEntity;
        this._isNistSupportEnabled = undefined;
        this._hasTopologyLicense = false;
        this._hasTopologyAccess = false;
        this._renderer = new Renderer(this);
        this._explorerState = {
            selectedIds: [],
            //openedEditor: undefined,
            openedTabs: {},
            activeTab: undefined,
        };

        this._optionMapSitePaths = [];

        this.columns = undefined;
        this._customFieldColumnsEntity = undefined;
        this._vendorApiConfigEntity = undefined;
        this._isEmitCustomFieldEvent = undefined;
        this._sessionStorage = undefined; //new UserGridData(`${this._gridKey}_explorerState`, null, { storageKey: 'deviceExplorer_explorerState', storageType: 'session' });
        this._osMap = undefined;
        this._licenseRestriction = licenseRestriction;
        this._CDALicenseEnabled = this._hasAccessToCDA();
        this._di = di;
        this._credentialsEntityDef = CredentialsEntity;
        this._credentialNameOptions = {};
        this._ValueMap = ValueMap;
        this._manufacturerOptions = {};
        this._modelOptions = {};
        this._deviceTypeOptions = {};
    }

    get columnConfig() {
        if (this.columns) {
            return this.columns;
        }

        //creating a new static DEVICE_TYPES list to pass to filter dropdown for types (via options)
        //TODO: create a non-redundant list directly in the filter
        const typeBaseMap = this._gameEditor._typeBaseMap;
        const optionMapDeviceTypes = {};
        _.sortBy(Object.keys(typeBaseMap)).map(function (key) {
            optionMapDeviceTypes[key] = {
                name: typeBaseMap[key],
                title: typeBaseMap[key],
            };
        });

        const optionMapAccessStatus = {};

        const optionControlType = {};
        Object.keys(this._DeviceEntityDef.getControlTypeLabels()).forEach(
            (controlType) =>
                (optionControlType[controlType] = {
                    name: controlType,
                    title: this._DeviceEntityDef.getControlTypeLabels()[controlType],
                })
        );

        const optionRestoreStatus = {};
        Object.keys(this._DeviceEntityDef.getLastRestoredStatusLabels()).forEach(
            (status) =>
                (optionRestoreStatus[status] = {
                    name: status,
                    title: this._DeviceEntityDef.getLastRestoredStatusLabels()[status],
                })
        );

        const optionBackupStatus = {};
        Object.keys(this._DeviceEntityDef.getLastBackupStatusLabels()).forEach(
            (status) =>
                (optionBackupStatus[status] = {
                    name: status,
                    title: this._DeviceEntityDef.getLastBackupStatusLabels()[status],
                })
        );

        const optionsSyncStatus = {};
        const optionsSyncStatusLabels = this._DeviceEntityDef.getCmdbSyncStatusLabels();
        Object.keys(optionsSyncStatusLabels).forEach((cmdbSyncStatus) => {
            optionsSyncStatus[cmdbSyncStatus] = {
                name: cmdbSyncStatus,
                title: optionsSyncStatusLabels[cmdbSyncStatus],
            };
        });

        this.columns = {
            grouping: {
                label: "Group",
                width: 220,
                entityColumn: true,
                isGroupingColumn: true,
            },
            detectedTypeBase: {
                label: "Type",
                columnRendererComponent: DeviceTypeColumn,
                entityColumn: true,
                width: 45,
                resizable: false,
                options: optionMapDeviceTypes,
                groupable: true,
                shown: true,
            },
            name: {
                label: "Name",
                width: 220,
                shown: true,
                groupable: false,
            },
            manufacturer: {
                label: "Manufacturer",
                shown: true,
                width: 140,
                groupable: true,
                options: this._manufacturerOptions || {},
            },
            deviceType: {
                label: "IoT Device Type",
                shown: true,
                width: 140,
                groupable: true,
                options: this._deviceTypeOptions || {},
            },
            model: {
                label: "Model",
                shown: true,
                width: 140,
                groupable: true,
                options: this._modelOptions || {},
            },
            osFamily: {
                label: "OS Family",
                shown: true,
                width: 140,
                groupable: true,
                options: OS_FAMILY_OPTIONS,
            },
            osName: {
                label: "OS Name",
                shown: true,
                width: 140,
                groupable: true,
            },
            osReleaseName: {
                label: "OS Release Name",
                shown: true,
                width: 140,
                groupable: true,
            },
            osVersion: {
                label: "OS Version",
                shown: true,
                width: 140,
                groupable: true,
            },
            machineArchitecture: {
                label: "Machine Architecture",
                shown: true,
                width: 140,
                groupable: true,
            },
            language: {
                label: "OS Language",
                shown: true,
                groupable: true,
                width: 140,
            },
            locale: {
                label: "Locale",
                shown: true,
                groupable: true,
                width: 140,
            },
            macAddresses: {
                label: "MAC Addresses",
                shown: true,
                width: 160,
                groupable: false,
            },
            offlineDiscoveryStatus: {
                label: "Offline Discovery Status",
                columnRendererComponent: DeviceDiscoveryStatusColumn,
                width: 140,
                options: DEVICE_DISCOVERY_STATUSES,
                groupable: true,
            },
            platformName: {
                label: "Platform Name",
                shown: true,
                width: 160,
                groupable: true,
            },
            xDomeDeviceId: {
                label: "xDome Device ID",
                width: 100,
                groupable: false,
            },
            description: {
                label: "Description",
                shown: true,
                width: 300,
                groupable: false,
            },
            managementState: {
                label: "Management State",
                columnRendererComponent: ManagementStateColumn,
                groupable: true,
                options: DEVICE_MANAGEMENT_STATES,
                width: 140,
            },
            environment: {
                label: "Environment",
                columnRendererComponent: EnvironmentColumn,
                groupable: true,
                shown: true,
                options: DEVICE_ENVIRONMENTS,
                width: 140,
            },
            sitePath: {
                label: "Site Path",
                groupable: true,
                width: 160,
                columnRendererComponent: SitePathColumn,
                context: {
                    orgName: this._userSession.activeOrganization.name,
                },
            },
            siteName: {
                label: "Site Name",
                groupable: false,
                width: 160,
            },
            siteCodeName: {
                label: "Site Code Name",
                columnRendererComponent: SiteCodeColumn,
                entityColumn: true,
                groupable: true,
                width: 160,
                context: {
                    hasTopologyLicense: this._hasTopologyLicense,
                    hasTopologyAccess: this._hasTopologyAccess,
                },
            },
            siteLocationType: {
                label: "Site Type",
                groupable: true,
                width: 160,
                options: Object.entries(this._siteEntityDef.getLocationTypeLabels()).map(
                    ([value, title]) => ({name: value, title})
                ),
                columnRendererComponent: SiteTypeColumn,
                context: {
                    _labels: this._siteEntityDef.getLocationTypeLabels(),
                },
            },
            allowSiteAutoAssignment: {
                label: "Allow site auto-assignment",
                groupable: true,
                width: 120,
                columnRendererComponent: CustomFieldsColumn,
            },
            licensed: {
                label: "Licensed",
                groupable: true,
                columnRendererComponent: LicenseColumn,
                options: LICENSE_STATUS,
                width: 140,
            },
            serialNumber: {
                label: "Serial",
                shown: true,
                groupable: false,
                width: 140,
            },
            lastUpgradePlan: {
                label: "Last OS Upgrade Plan",
                groupable: true,
                width: 160,
            },
            osUpgradeStatus: {
                label: "OSM Action Status",
                groupable: true,
                columnRendererComponent: PlanStatusColumn,
                context: {
                    _planStatusList: this._DeviceEntityDef.getOfflineUpgradeStatusValues(),
                },
                width: 160,
            },
            osUpgradedOn: {
                label: "OSM Action On",
                groupable: false,
                columnRendererComponent: DateColumn,
                width: 160,
            },
            licenseCount: {
                label: "License Count",
                groupable: false,
                width: 110,
            },
            updatedOn: {
                label: "Updated On",
                columnRendererComponent: DateColumn,
                groupable: false,
                width: 160,
            },
            updatedBy: {
                label: "Updated By",
                width: 120,
                groupable: true,
            },
            lastActivityType: {
                label: "Last Activity Type",
                groupable: true,
            },
            lastActivityOn: {
                label: "Last Activity On",
                columnRendererComponent: DateColumn,
                shown: true,
                width: 160,
                groupable: false,
            },
            lastActivityBy: {
                label: "Last Activity By",
                width: 120,
                groupable: true,
            },
            lastActivityError: {
                label: "Last Activity Error",
                groupable: true,
            },
            cmdbCiId: {
                label: "CMDB CI ID",
                groupable: false,
            },
            cmdbCiName: {
                label: "CMDB CI Name",
                groupable: false,
            },
            cmdbClassName: {
                label: "CMDB Class Name",
                groupable: true,
            },
            cmdbSyncStatus: {
                label: "CMDB Sync Status",
                groupable: true,
                options: optionsSyncStatus,
                columnRendererComponent: CmdbSyncStatusColumn,
                context: {
                    cmdbSyncStatusOptions: this._DeviceEntityDef.getCmdbSyncStatusLabels(),
                },
            },
            lastCmdbSyncBy: {
                label: "Last CMDB Sync By",
                groupable: true,
            },
            lastCmdbSyncError: {
                label: "Last CMDB Sync Error",
                groupable: true,
            },
            lastCmdbSyncOn: {
                label: "Last CMDB Sync On",
                groupable: false,
                columnRendererComponent: DateColumn,
            },
            discoveryUploadedBy: {
                label: "Discovery Uploaded By",
                width: 120,
                groupable: true,
            },
            discoveryUploadedOn: {
                label: "Discovery Uploaded On",
                width: 120,
                groupable: false,
                columnRendererComponent: DateColumn,
            },
            offlineDiscoveredBy: {
                label: "Offline Discovered By",
                width: 120,
                groupable: true,
            },
            offlineDiscoveredOn: {
                label: "Offline Discovered On",
                width: 120,
                groupable: false,
                columnRendererComponent: DateColumn,
            },
            offlineDiscoveryError: {
                label: "Offline Discovery Error",
                width: 120,
                groupable: true,
            },
            discoveryCopiedFromDeviceId: {
                label: "Discovery Copied From Device ID",
                width: 140,
                groupable: false,
            },
            cmdbSerialNumber: {
                label: "Serial Number from CMDB",
                groupable: false,
            },
            lastUpgradePlan: {
                label: "Last OS Upgrade Plan",
                groupable: true,
            },
            upgradeUploadedOn: {
                label: "Upgrade Uploaded On",
                groupable: false,
                columnRendererComponent: DateColumn,
            },
            upgradeUploadedBy: {
                label: "Upgrade Uploaded By",
                groupable: true,
            },
            offlineUpgradedOn: {
                label: "Upgraded On",
                groupable: false,
                columnRendererComponent: DateColumn,
            },
            offlineUpgradedBy: {
                label: "Upgraded By",
                groupable: true,
            },
            offlineUpgradeStatus: {
                label: "OS Upgrade Status",
                groupable: true,
            },
            offlineUpgradeError: {
                label: "Offline Upgrade Error",
                groupable: true,
            },
            tagNames: {
                label: "Tags",
                filterLabel: "Tag Name",
                columnRendererComponent: TagsColumn,
                width: 160,
                dataType: "array",
                groupable: false,
                shown: false,
            },
        };

        // Get current solution name and determine which columns should be shown
        const currentSolutionName = this.gameEditor.currentSolutionName || "device_manager";
        const defaultShownColumns =
            SOLUTION_DEFAULT_SHOWN_COLUMNS_IOT[currentSolutionName] ||
            SOLUTION_DEFAULT_SHOWN_COLUMNS_IOT["device_manager"];

        Object.keys(this.columns).forEach((columnKey) => {
            // Set 'shown' property to true for each column based on SOLUTION_DEFAULT_SHOWN_COLUMNS_IOT
            // and assign a priority to each column
            if (defaultShownColumns.includes(columnKey)) {
                this.columns[columnKey].shown = true;
                this.columns[columnKey].priority = defaultShownColumns.indexOf(columnKey) + 1;
            } else {
                this.columns[columnKey].shown = false;
            }
        });

        // Filter out license-restricted columns if user doesn't have the required license
        const hasCDALicense = this._licenseRestriction?.checkLicense("CDA");
        const hasOSMLicense = this._licenseRestriction?.checkLicense("OSM");

        if (!hasCDALicense && LICENSE_RESTRICTED_COLUMNS.CDA) {
            LICENSE_RESTRICTED_COLUMNS.CDA.forEach((columnKey) => {
                delete this.columns[columnKey];
            });
        }

        if (!hasOSMLicense && LICENSE_RESTRICTED_COLUMNS.OSM) {
            LICENSE_RESTRICTED_COLUMNS.OSM.forEach((columnKey) => {
                delete this.columns[columnKey];
            });
        }

        return this.columns;
    }

    get pagingFeed() {
        return this._pagingDeviceFeed;
    }

    get selectedRows() {
        return this._renderer.selectedRows;
    }

    get activeOrgId() {
        return this._userSession.activeOrganization.id;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        // this._solutionsManager.on("activeSolutionChanged", (this._onSolutionChanged = this._onSolutionChanged.bind(this)));
        this._storageFactory.on(
            "storageReady",
            (this._onStorageReady = this._onStorageReady.bind(this))
        );
        this._gameEditor.on(
            "EditorLaunched",
            (this._onEditorLaunched = this._onEditorLaunched.bind(this))
        );
        this._gameEditor.on(
            "EditorClosed",
            (this._onEditorClosed = this._onEditorClosed.bind(this))
        );
        this._gameEditor.on("ActiveTabChanged", this._onActiveTabChanged.bind(this));
    }

    _unregisterListeners() {
        // this._solutionsManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        if (this._storageFactory) {
            this._storageFactory.removeListener("storageReady", this._onStorageReady);
        }
        if (this._gameEditor) {
            // this._gameEditor.removeListener("EditorLaunched", this._onEditorLaunched);
            // this._gameEditor.removeListener("EditorClosed", this._onEditorClosed);
            // this._gameEditor.removeListener("ActiveTabChanged", this._onActiveTabChanged);
            this._gameEditor.removeAllListeners();
        }
    }

    _patchSorting(sorting) {
        // add second sorting order by name
        if (sorting && !sorting.name && this.columnConfig.name) {
            sorting.name = 1;
        }
    }

    _registerFeedListeners() {}

    _unregisterFeedListeners() {}

    _registerUpdatedColumnListeners() {
        this._customFieldColumnsEntity.on(
            "PropertiesUpdated",
            (this._onPropertiesUpdated = this._onPropertiesUpdated.bind(this))
        );
    }

    _unregisterUpdatedColumnListeners() {
        if (this._customFieldColumnsEntity) {
            this._customFieldColumnsEntity.removeListener(
                "PropertiesUpdated",
                this._onPropertiesUpdated
            );
        }
    }

    _loadFieldOptions() {
        return this._ValueMap
            .loadValueMapByName(this._userSession.activeOrganization.id, "xdome")
            .then((vendorOsMapEntity) => {
                const fieldMappings = vendorOsMapEntity.valueMap;
                this._deviceTypeOptions = this._generateOptionsForField(fieldMappings.deviceType);
                this._manufacturerOptions = this._generateOptionsForField(
                    fieldMappings.manufacturer
                );
                this._modelOptions = this._generateOptionsForField(fieldMappings.model);
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "IotDeviceGridViewComponent._loadFieldOptions() error - using empty options"
                );
                this._deviceTypeOptions = {};
                this._manufacturerOptions = {};
                this._modelOptions = {};
                return Promise.resolve();
            });
    }

    _generateOptionsForField(fieldMapObj) {
        if (!fieldMapObj) {
            return {};
        }
        const options = {};
        Object.keys(fieldMapObj)
            .filter((key) => fieldMapObj[key])
            .forEach((key) => {
                options[key] = {
                    name: key,
                    title: key,
                };
            });
        return options;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenModelIsReady(selectedSite) {
        return this.gameEditor
            .whenInitialized()
            .then(() => this._getNodeProps())
            .then(() => {
                return this._DeviceEntityDef
                    .loadAndMergeOsMap(this._gameEditor._activeOrgId)
                    .then((val) => {
                        this._osMap = val;
                        return Promise.resolve();
                    });
            })
            .then(() => {
                this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                    "entity_grid_gl",
                    this._gridKey
                );
                this._sessionStorage = this._storageFactory.getSessionStorageInstance(
                    "entity_grid_gl",
                    `${this._gridKey}_explorerState`
                );
                this._explorerState = Object.assign(
                    {},
                    this._explorerState,
                    this._sessionStorage.getData()
                );
            })
            .then(() => this._loadFieldOptions())
            .then(() => this._getExtendedPropTypes())
            .then(() => this._getAllTags())
            .then((tagOptions) => {
                this._tagOptions = tagOptions;
                return Promise.all([
                    this._VendorApiConfigEntityDef.loadVendorApiConfig(this.activeOrgId, {
                        vendors: true,
                    }),
                    this._CustomFieldsEntityDef.loadColumnDefinitions(this.activeOrgId),
                    this._CustomFieldsEntityDef.retrieveCustomFields(this.activeOrgId),
                ]);
            })
            .then(async (response) => {
                const vendorApiConfig = response[0],
                    customFieldColumns = response[1],
                    customColumnsEntity = response[2];
                this.treeData = TreeUtils.generateTreeNodesFromRaw(
                    this.gameEditor.sitePaths,
                    "path",
                    selectedSite
                ).items;

                if (
                    vendorApiConfig &&
                    vendorApiConfig.properties.vendors &&
                    vendorApiConfig.properties.vendors.cisco &&
                    typeof vendorApiConfig.properties.vendors.cisco.enabled !== "undefined"
                ) {
                    this._isCiscoSupportEnabled = vendorApiConfig.properties.vendors.cisco.enabled;
                } else {
                    this._isCiscoSupportEnabled = false;
                }
                if (
                    vendorApiConfig &&
                    vendorApiConfig.properties.vendors &&
                    vendorApiConfig.properties.vendors.nist &&
                    typeof vendorApiConfig.properties.vendors.nist.enabled !== "undefined"
                ) {
                    this._isNistSupportEnabled = vendorApiConfig.properties.vendors.nist.enabled;
                } else {
                    this._isNistSupportEnabled = false;
                }
                // return this._CustomFieldsEntityDef.loadColumnDefinitions(this.activeOrgId);
                // })
                // .then((customFieldColumns) => {
                this._hasTopologyLicense = this._licenseRestriction.checkLicense("TOP");
                this._hasTopologyAccess =
                    _.get(this._userSession, "_userEntity.authorizedActions", []).indexOf(
                        "topologyAccess"
                    ) >= 0;
                let additionalDataFields = [
                    "connectionMethod",
                    "connectionInformation",
                    "customFieldValues",
                    "detectedRawTypeBase",
                    "engineZoneId",
                    "cves",
                    "siteId",
                    "lockEngine",
                    "nodeProps",
                    "discoveryLevelFrom",
                    "customFieldSources",
                    "edpValues",
                ];

                // Get existing labels from columnConfig to avoid duplicates with nodeProps
                const existingLabels = new Set(
                    Object.values(this.columnConfig).map((prop) => prop.label)
                );

                // Add nodeProps to columnConfig
                Object.entries(this._nodeProps).forEach(([rawId, props]) => {
                    const label = rawId.replace(/[\t\n\r ]+/g, " ");
                    const technicalId = label.replace(/ /g, "");

                    // Skip if already in columnConfig
                    if (existingLabels.has(label)) {
                        return;
                    }

                    // Add nodeProp to columnConfig
                    this.columnConfig[technicalId] = {
                        ...props,
                        id: technicalId,
                        label,
                        path: `nodeProps["${rawId}"]`,
                        dataType: props.type,
                        shown: false,
                    };

                    // Add options for enum types
                    let options = undefined;
                    if (props.type === "enum") {
                        if (props.options && Object.keys(props.options).length > 0) {
                            // Shallow clone to avoid mutating source
                            this.columnConfig[technicalId].options = {...props.options};
                        } else if (Array.isArray(props.values)) {
                            // Convert array of values to object map
                            this.columnConfig[technicalId].options = props.values.reduce(
                                (acc, val) => {
                                    acc[val] = {name: val, title: val};
                                    return acc;
                                },
                                {}
                            );
                        } else {
                            this.columnConfig[technicalId].options = {};
                        }
                    }
                });

                let customFieldOrder = _.map(DEVICE_CUSTOM_FIELDS, "id");

                let enabledCustomColumns = Object.entries(customFieldColumns)
                    .filter(
                        ([id, customField]) =>
                            customField.enabled === true &&
                            (customField.systemOwned !== true ||
                                _.get(
                                    customColumnsEntity,
                                    `_pristineProperties.fields.${id}.source`,
                                    ""
                                ) === "ControllerDiscoveryConfig" ||
                                this._isCiscoSupportEnabled ||
                                this._isNistSupportEnabled ||
                                this._gameEditor._xDomeEnabled)
                    )
                    .map(([key, customField]) => {
                        // Update order value for pre-ordered custom fields
                        customField = customFieldOrder.includes(key)
                            ? _.set(customField, "order", customFieldOrder.indexOf(key))
                            : customField;
                        return [key, customField];
                    })
                    .sort(([, /*aKey*/ aCustomField], [, /*bKey*/ bCustomField]) =>
                        // Sort custom fields according to its 'order'
                        this._CustomFieldsEntityDef
                            .getSortingComparator("order")
                            .call(null, aCustomField, bCustomField)
                    )
                    .map(([key, customField], idx) => {
                        // Build grid column object for each custom field
                        const predefinedCustomField = _.find(DEVICE_CUSTOM_FIELDS, {id: key});
                        const columnRendererComponent = _.get(
                            predefinedCustomField,
                            "columnRenderer",
                            CustomFieldsColumn
                        );
                        const customFieldColumn = {
                            label: customField.label,
                            description: customField.description || customField.label,
                            entityColumn: false,
                            shown: false,
                            path: `customFieldValues.${key}`,
                            dataType: String(customField.dataType).toLowerCase(),
                            typeInfo: customField.typeInfo || {},
                            context: _.clone(customField),
                            columnRendererComponent,
                        };

                        const {labels, ids, multiSelect} = customFieldColumn.typeInfo || {};
                        if (labels && ids && multiSelect !== true) {
                            customFieldColumn.options = ids.reduce(
                                (options, id, idx) =>
                                    Object.assign(options, {[id]: {title: labels[idx]}}),
                                {}
                            );
                        }

                        return {[key]: customFieldColumn};
                    });

                if (!this._isCiscoSupportEnabled && this._isNistSupportEnabled) {
                    const type1CustomFields = _.map(
                        DEVICE_CUSTOM_FIELDS.filter((i) => i.type === 1),
                        "id"
                    );

                    enabledCustomColumns = enabledCustomColumns.filter((obj) => {
                        const key = Object.keys(obj)[0];

                        if (_.indexOf(type1CustomFields, key) > -1) {
                            return false;
                        }
                        return true;
                    });
                }

                _.assign(this.columnConfig, ...enabledCustomColumns);

                // Optimise column width if needed
                const PIXELS_PER_CHAR = 8;
                const PADDING = 13;
                const MIN_WIDTH = 5;
                const MAX_WIDTH = 300;
                Object.keys(this.columnConfig).forEach((columnKey) => {
                    // Set width based on label length
                    const labelLength = this.columnConfig[columnKey].label?.length || 0;
                    const labelWidth = labelLength * PIXELS_PER_CHAR + PADDING;
                    const width = Math.max(MIN_WIDTH, Math.min(labelWidth, MAX_WIDTH));

                    if (
                        !_.isNumber(this.columnConfig[columnKey].width) ||
                        this.columnConfig[columnKey].width < width
                    ) {
                        this.columnConfig[columnKey].width = width;
                    }
                });

                const basicFilterQuery = _.get(
                    this._userGridData.getBasicSearchData(),
                    "filterQuery",
                    {}
                );
                const advancedFilterQuery = this._userGridData.getAdvancedSearchData();

                const userSorting = this._userGridData.getSorting() || {};

                this._patchSorting(userSorting);

                let filterQuery = !_.isEmpty(advancedFilterQuery)
                    ? advancedFilterQuery
                    : basicFilterQuery;
                const oldQuery = _.clone(filterQuery);
                switch (this._solutionName) {
                    case "device_manager":
                    case "data_explorer":
                    case "os_manager":
                        filterQuery = {
                            $userQuery: oldQuery,
                            $systemQuery: {},
                        };
                        break;
                    case "config_drift":
                        filterQuery = {
                            $userQuery: oldQuery,
                            $systemQuery: {managementState: {$in: ["MANAGED", "UNMANAGED"]}},
                        };
                        break;
                }
                if (selectedSite) {
                    // console.log(selectedSite, this.treeData);
                    const {pathVals, selectedSitePath} = TreeUtils.getAllChildrenPathsFromId(
                        this.treeData,
                        selectedSite
                    );
                    if (selectedSitePath === "/") {
                        this._filterForTree = {};
                    } else if (pathVals) {
                        this._filterForTree = {sitePath: {$in: pathVals}};
                    }
                    // this._updateFilter("ontoggle", false, false);
                }
                if (typeof filterQuery !== "object") {
                    filterQuery = {};
                }
                let _filter = JSON.parse(JSON.stringify(filterQuery));

                // Initialize $userQuery if it doesn't exist
                _filter.$systemQuery = _filter.$systemQuery || {};

                // Ensure $userQuery.$and exists and is an array
                if (!_filter.$systemQuery.$and || !Array.isArray(_filter.$systemQuery.$and)) {
                    _filter.$systemQuery.$and = [];
                }

                // Always append deviceRawCategory: 'iot' to $and
                _filter.$systemQuery.$and.push({deviceRawCategory: "iot"});

                // if (this._solutionName === "os_manager") {
                //     _filter.$systemQuery.$and.push({offlineDiscoveryStatus: "DISCOVERED"});
                // }

                if (!_.isEmpty(this._filterForTree)) {
                    let userQ = {};
                    if (_filter.$userQuery) {
                        if (_filter.$userQuery.$and) {
                            userQ.$and = _filter.$userQuery.$and;
                        } else if (_filter.$userQuery.$or) {
                            userQ.$and = [{$or: _filter.$userQuery.$or}];
                        } else {
                            userQ.$and = [];
                        }
                    } else {
                        userQ.$and = [];
                    }
                    userQ.$and.push(this._filterForTree);
                    _filter.$userQuery = userQ;
                }
                this._pagingDeviceFeed = new PagingDeviceFeed({
                    feedKey: this._gridKey + "_feed",
                    activeOrgId: this.activeOrgId,
                    entityDef: this._DeviceEntityDef,
                    columnConfig: this.columnConfig,
                    filter: _filter,
                    sort: userSorting,
                    additionalDataFields,
                });
                this._registerListeners();
                // return this._CustomFieldsEntityDef.retrieveCustomFields(this.activeOrgId);
                // })
                // .then((customColumnsEntity) => {
                this._customFieldColumnsEntity = customColumnsEntity;
                this._registerUpdatedColumnListeners();
            })
            .then(() => {
                if (this._solutionName === "os_manager") {
                    this._imageServersFeed = this._establishImageServersFeed(this.activeOrgId).then(
                        () => {
                            this._statusBar = this._initStatusBar();
                            return this.whenFeedIsReady();
                        }
                    );
                } else {
                    return this.whenFeedIsReady();
                }
            });
    }
    wasFeedPreviouslyInitialized() {
        return this._pagingDeviceFeed.wasPreviouslyInitialized();
    }

    whenFeedIsReady() {
        return this._pagingDeviceFeed.whenFeedReady();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterFeedListeners();
        this._unregisterListeners();
        this._unregisterUpdatedColumnListeners();
        let shutdowns = [
            this._renderer.shutdown(),
            _.isUndefined(this._pagingDeviceFeed)
                ? Promise.resolve()
                : this._pagingDeviceFeed.shutdown(),
            _.isUndefined(this._sessionStorage)
                ? Promise.resolve()
                : this._sessionStorage.shutdown(),
        ];

        return Promise.all(shutdowns).then(
            () => {
                //this._gameEditor._unregisterDeviceExplorerListeners();
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._steveUtils = undefined;
                this._explorerState = undefined;
                this._pagingDeviceFeed = undefined;
                this._VendorApiConfigEntityDef = undefined;
                this._isCiscoSupportEnabled = undefined;
                this._isNistSupportEnabled = undefined;
                this._DeviceEntityDef = undefined;
                this._userSession = undefined;
                this._controlledDeviceNames = undefined;
                this._controlledDeviceIDs = undefined;
                this._modalUserFeedback = undefined;
                this._solutionsManager = undefined;
                this._solutionName = undefined;
                this._gridKey = undefined;
                this._userGridData = undefined;
                this._sessionStorage = undefined;
                this._logger = undefined;
                this._customFieldColumnsEntity = undefined;
                this._isEmitCustomFieldEvent = undefined;
                this._siteEntityDef = undefined;
                this._constructTypeEntityDef = undefined;
                this._nodeProps = undefined;
                this._TagsEntity = undefined;
                this._tags = undefined;
                this._tagOptions = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "IotDeviceGridViewComponent.shutdown() error");
            }
        );
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }

    setExplorerState(val) {
        this._explorerState = val;
    }

    updateExplorerState(property, val) {
        if (val === undefined) {
            this._sessionStorage.removeData(property);
            _.unset(this._explorerState, property);
        } else {
            this._sessionStorage.setData(val, property);
            _.set(this._explorerState, property, val);
        }
    }

    get isCiscoSupportEnabled() {
        return this._isCiscoSupportEnabled;
    }

    set isCiscoSupportEnabled(isEnabled) {
        this._isCiscoSupportEnabled = isEnabled;
    }

    get isNistSupportEnabled() {
        return this._isNistSupportEnabled;
    }

    set isNistSupportEnabled(isEnabled) {
        this._isNistSupportEnabled = isEnabled;
    }

    resetSelection(newIds) {
        let selectedIds = [];

        if (newIds && newIds.length) {
            newIds.forEach((id) => {
                selectedIds.push(id);
            });
        }

        this.renderer._deviceEntityGrid.setSelectedRows(selectedIds);
        this.updateExplorerState("selectedIds", {selectedRows: selectedIds});
        this.renderer._renderAvailableActions();
    }

    loadAndScrollTo(entityId) {
        let that = this;
        this.pagingFeed.on("RequestedEntityFound", handleRequestedEntityFound);
        this.pagingFeed._requestEntity(entityId);

        function handleRequestedEntityFound(index) {
            that.renderer._deviceEntityGrid.renderer.scrollToTheRow(index);
            that.pagingFeed.removeListener("RefreshView", handleRequestedEntityFound);
        }
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onEditorClosed(tabId /*, editorParams*/) {
        //let editorsIds = editorParams.launchOptions.deviceIds;
        if (this._explorerState.openedTabs[tabId]) {
            delete this._explorerState.openedTabs[tabId];
            if (
                Object.keys(this._explorerState.openedTabs).length === 1 &&
                this._explorerState.openedTabs.sessionToken
            ) {
                delete this._explorerState.openedTabs.sessionToken;
            }
        }
        if (this._explorerState.activeTab === tabId) {
            if (!_.isEmpty(this._explorerState.openedTabs)) {
                let openedTabsIds = Object.keys(this._explorerState.openedTabs);
                this.updateExplorerState("activeTab", openedTabsIds[openedTabsIds.length - 1]);
            } else {
                this.updateExplorerState("activeTab", undefined);
            }
        }
        this.updateExplorerState("openedTabs", this._explorerState.openedTabs);
    }

    _onActiveTabChanged(tabId /*, editorParams*/) {
        if (this._explorerState.activeTab !== tabId) {
            this.updateExplorerState("activeTab", tabId);
        }
    }

    _onEditorLaunched(editorState, launchOpts) {
        if (!this._explorerState.openedTabs[launchOpts.id]) {
            let openedTab = Object.assign(editorState, launchOpts);
            this._explorerState.openedTabs[launchOpts.id] = openedTab;
            this.updateExplorerState("openedTabs", this._explorerState.openedTabs);
        }
        this.updateExplorerState("activeTab", launchOpts.id);
    }

    onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columnConfig[sortData.sortColumn]) {
                return;
            }
            const sortCriteria =
                this.columnConfig[sortData.sortColumn].valuePath ||
                this.columnConfig[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        this._patchSorting(sort);

        this._pagingDeviceFeed.setSort(sort);
    }

    _onSolutionChanged(solution) {
        // whole pane will be reset, no need to make any action here
        this._solutionName = solution.name;
    }

    _onStorageReady() {}

    _onPropertiesUpdated(pristineProperties, before) {
        this._isEmitCustomFieldEvent = false;
        let updatedColumnKeys = pristineProperties.fields;
        let previousColumnKeys = before.fields;
        let editedColumn = Object.assign(
            {},
            ..._.reduce(
                updatedColumnKeys,
                (result, value, key) => {
                    return _.isEqual(value, previousColumnKeys[key])
                        ? result
                        : result.concat({
                              [key]: value,
                          });
                },
                []
            )
        );
        if (Object.keys(updatedColumnKeys).length !== Object.keys(previousColumnKeys).length) {
            this._isEmitCustomFieldEvent = true;
        } else {
            for (let key of Object.keys(editedColumn)) {
                if (
                    !updatedColumnKeys[key].enabled &&
                    updatedColumnKeys[key].enabled === previousColumnKeys[key].enabled
                ) {
                    this._isEmitCustomFieldEvent = false;
                } else {
                    this._isEmitCustomFieldEvent = true;
                    break;
                }
            }
        }
        if (this._isEmitCustomFieldEvent) {
            this.emit("GridColumnUpdated", pristineProperties, before);
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    async _establishImageServersFeed(orgId) {
        if (!orgId) {
            return;
        }
        const query = {};
        const fields = [
            "enabled",
            "name",
            "identifier",
            "ip",
            "status",
            "percentFull",
            "isMain",
        ].reduce((fields, field) => Object.assign(fields, {[field]: true}), {});

        const sort = {createdOn: 1};
        if (this._imageServersFeed) {
            await this._imageServersFeed.whenInitialized();
            await this._imageServersFeed.reestablishFeed(orgId, query, fields, sort);
        } else {
            this._imageServersFeed = await this._osImageServerEntity.startAscendOsImageServersFeed(
                orgId,
                query,
                fields,
                sort
            );
            this._registerImageServersFeedListeners(this._imageServersFeed);
        }

        return this._imageServersFeed;
    }

    _initStatusBar() {
        this._defaultDiOpts = {
            defaultInjectables: ["$teve.logger", "eventEmitter.eventEmitter"],
        };

        let diOpts = _.cloneDeep(this._defaultDiOpts) || {};
        diOpts.injectableOverrides = {
            //"gameEditor.gameEditor": this
            "eventEmitter.eventEmitter": this,
        };

        return this._di.createInstance(Registrations.DEVICE_EXPLORER_STATUS_BAR, diOpts);
    }

    _onImageServerFeedUpdate(feed) {
        this.emit("ImageServersUpdated", feed.getCacheAsArray());
    }

    _registerImageServersFeedListeners(feed) {
        const onFeedUpdate = _.debounce(this._onImageServerFeedUpdate.bind(this), 0);

        feed.on("ChangeFeedInitialized", (data, feed /*, reInit*/) => {
            onFeedUpdate(feed, "ChangeFeedInitialized");
        })
            .on("EntityInitialized", () => {
                onFeedUpdate(feed, "EntityInitialized");
            })
            .on("EntityPropertiesUpdated", (entity, patches, props, feed) => {
                onFeedUpdate(feed, "EntityPropertiesUpdated");
            })
            .on("EntityAdded", (entity, properties, feed) => {
                onFeedUpdate(feed, "EntityAdded");
            })
            .on("EntityRemoved", (entity, cause, feed) => {
                onFeedUpdate(feed, "EntityRemoved");
            })
            .once("ShutdownStarted", () => {
                onFeedUpdate.cancel();
                feed.removeListener("ChangeFeedInitialized", onFeedUpdate)
                    .removeListener("EntityInitialized", onFeedUpdate)
                    .removeListener("EntityPropertiesUpdated", onFeedUpdate)
                    .removeListener("EntityAdded", onFeedUpdate)
                    .removeListener("EntityRemoved", onFeedUpdate);
            });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    openDeviceInstanceEditor(ids, fullyQualifiedViewName) {
        if (Array.isArray(ids) && ids.length > 1) {
            this._gameEditor.launchDeviceMultiEditor(ids);
        } else if ((Array.isArray(ids) && ids.length) || (typeof ids === "string" && ids !== "")) {
            const id = Array.isArray(ids) ? ids[0] : ids,
                fqn = fullyQualifiedViewName || Registrations.DIE_VIEW_DETAILS,
                device = this._pagingDeviceFeed.getDeviceEntityById(id),
                title = _.get(device, "name", "");
            this._gameEditor.launchDeviceEditor(
                {
                    fqn,
                },
                {
                    id,
                    title,
                }
            );
        }
    }

    openNetworkDiscoveryEditor(ids = [], openFromUrl = false) {
        let editorState = {
            fqn: Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS,
        };
        let launchOpts = {
            id: this.activeOrgId,
            title: "Network Discovery",
            type: "NetworkDiscovery",
            selectedDevice: ids || [],
            openFromURL: openFromUrl,
        };
        this._gameEditor.launchNetworkDiscoveryEditor(editorState, launchOpts);
    }

    getSelectedDeviceIds() {
        return _.get(this._explorerState, "selectedIds", []);
    }

    _hasAccessToCDA() {
        const hasPermission = !!_.get(this._userSession._userEntity, "authorizedActions").filter(
            (action) => action === "configDriftAndAuditAccess"
        ).length;
        const hasLicense = this._licenseRestriction.checkLicense("CDA");

        if (hasPermission && hasLicense) {
            return true;
        }
        return false;
    }

    _getOsPlanDataForAdvancedFilter(data) {
        let clonedData = _.clone(data);
        let newObj = {};
        for (let key in clonedData) {
            let value = {};
            value[key] = {
                name: key,
                title: clonedData[key],
            };
            newObj = Object.assign(newObj, value);
        }
        return newObj;
    }

    async _getNodeProps() {
        this._nodeProps = await this._constructTypeEntityDef.getDeviceNodePropDefs(
            this.activeOrgId
        );
        return Promise.resolve();
    }

    // Options for the id-based Tags filter: the DB value is the tag id, the display is its name.
    async _getAllTags() {
        this._tags = await this._TagsEntity.loadTags(this.activeOrgId);
        return this._tags.map(({id, name}) => ({name: id, title: name}));
    }

    async _getExtendedPropTypes() {
        this._extendedPropTypes = await this._extendedPropTypeEntityDef.loadExtendedPropTypes(
            this.activeOrgId,
            {
                enabled: {$ne: false},
                $or: [
                    {schemaTypes: {$exists: false}},
                    {schemaTypes: {$size: 0}},
                    {schemaTypes: "odm"},
                ],
            }
        );

        if (this._extendedPropTypes.length > 0) {
            const edpColumns = {};

            this._extendedPropTypes.forEach((extendedPropType) => {
                const {deviceExplorerFieldMap: columns, extensionType} =
                    extendedPropType.getPristineProperties();

                Object.entries(columns).forEach(([key, value]) => {
                    const columnKey = `edpValues.${extensionType}.${key}`;
                    const columnConfig = {
                        label: value.displayName,
                        dataType: value.dataType,
                        shown: false,
                        path: columnKey,
                    };

                    // Add options if enum type
                    if (value.dataType === "enum") {
                        const options = {};
                        if (Array.isArray(value.options)) {
                            value.options.forEach((val) => {
                                options[val] = {name: val, label: val};
                            });
                        } else {
                            Object.entries(value.options).forEach(([key, val]) => {
                                options[key] = {name: val, label: key};
                            });
                        }
                        columnConfig.options = options;
                    }

                    // Add groupable if applicable
                    if (value?.display?.groupable) {
                        columnConfig.groupable = true;
                    }

                    edpColumns[columnKey] = columnConfig;
                });
            });

            Object.assign(this.columnConfig, edpColumns);
        }

        return Promise.resolve();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = IotDeviceGridViewComponent;

IotDeviceGridViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.utils",
    "$teve.entities.Device",
    "$teve.entities.VendorApiConfig",
    "$teve.entities.CustomFields",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.ui.userFeedback",
    "$teve.licenseRestriction",
    "$teve.entities.OsImageServer",
    "$teve.di",
    "$teve.entities.Site",
    "$teve.entities.Credentials",
    "$teve.entities.ConstructType",
    "$teve.entities.ExtendedPropType",
    "$teve.entities.ValueMap",
    "$teve.entities.Tags",
];

IotDeviceGridViewComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "common.switch",
    shown: false,
    order: 1,
};
